import { StyledNewProductForm } from './style';
import { useIntl } from 'react-intl';
import { Input } from '../../Input';
import { publicPath } from 'enums/publicRoutes';
import { message } from 'antd';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';

export interface shareProps {
  productId?: number;
  productSlug?: string;
}

export const ShareProductForm = ({ productId, productSlug }: shareProps) => {
  const intl = useIntl();

  const productLink = `${window.location.origin}${publicPath.product(
    productSlug,
    productId
  )}`;
  const wholesaleProductLink = `${window.location.origin}${publicPath.wholesaleProduct(
    productSlug,
    productId
  )}`;

  const Suffix = () => {
    const handleCopyClick = () => {
      navigator.clipboard.writeText(productLink).catch((err) => {
        message.error(intl.formatMessage({ id: 'message.fail_copy' }), err);
      });
      message.success(intl.formatMessage({ id: 'message.success_copy' }));
    };

    return (
      <div onClick={handleCopyClick} className={'suffix'}>
        <img src={'/svgs/copy-icon.svg'} alt="copy icon" />
        <span>{intl.formatMessage({ id: 'products.copy' })}</span>
      </div>
    );
  };

  return (
    <StyledNewProductForm>
      <div className={'copy-product'}>
        <div className={'label'}>
          {intl.formatMessage({ id: 'products.copy_link' })}
        </div>
        <Input value={productLink} suffix={<Suffix />} />
      </div>
      <div className={'social-icons'}>
        <FacebookShareButton url={productLink}>
          <img src={'/svgs/socials/facebook.svg'} alt="facebook share" />
        </FacebookShareButton>
        <TwitterShareButton url={productLink}>
          <img src={'/svgs/socials/twitter.svg'} alt="twitter share" />
        </TwitterShareButton>
        <LinkedinShareButton url={productLink}>
          <img src={'/svgs/socials/linkedin.svg'} alt="linkedin share" />
        </LinkedinShareButton>
        <WhatsappShareButton url={productLink}>
          <img src={'/svgs/socials/whatsapp.svg'} alt="whatsapp share" />
        </WhatsappShareButton>
      </div>
      <div className={'copy-product'}>
        <div className={'label'}>
          {intl.formatMessage({ id: 'products.copy_link_wholesale' })}
        </div>
        <Input value={wholesaleProductLink} suffix={<Suffix />} />
      </div>
      <div className={'social-icons'}>
        <FacebookShareButton url={wholesaleProductLink}>
          <img src={'/svgs/socials/facebook.svg'} alt="facebook share" />
        </FacebookShareButton>
        <TwitterShareButton url={wholesaleProductLink}>
          <img src={'/svgs/socials/twitter.svg'} alt="twitter share" />
        </TwitterShareButton>
        <LinkedinShareButton url={wholesaleProductLink}>
          <img src={'/svgs/socials/linkedin.svg'} alt="linkedin share" />
        </LinkedinShareButton>
        <WhatsappShareButton url={wholesaleProductLink}>
          <img src={'/svgs/socials/whatsapp.svg'} alt="whatsapp share" />
        </WhatsappShareButton>
      </div>
    </StyledNewProductForm>
  );
};
